export const getStatFontSize = (value) => {
    const len = `${value}`.length;
    if (len > 17) return '24px'; 
    if (len > 16) return '28px'; 
    if (len > 12) return '34px'; 
    if (len > 10) return '40px';
    if (len > 8)  return '44px';
    return '48px';
};